namespace Portico.Models.Legacy {

    export class IResponseModelMemberNumberStatusResultModel {
        success: boolean;
        messages: Array<string>;
		data: MemberNumberStatusResultModel
        constructor(obj?: Portico.Services.Legacy.CardService.Models.IResponseModelMemberNumberStatusResultModel) {
            this.success = null;
            this.messages = null;
            this.data = null;

            if (obj) {
                this.success = obj.success || false;
                this.messages = (obj.messages || []).concat();
                this.data = obj.data ? new MemberNumberStatusResultModel(obj.data || null):null;
            }
        }

        public toModel(): Portico.Services.Legacy.CardService.Models.IResponseModelMemberNumberStatusResultModel {
            return {
                success: this.success,
                messages: (this.messages || []).concat(),
				data: this.data ? this.data.toModel() : null
            };
        }
    }
}